<template>
  <div class="discovery scrollstyle">
    <div style="margin-right: 8px;margin-left: 8px;">
      <h2 class="discovery-title">
        {{ $t('discovery_14') }}
      </h2>
      <!-- <img class="banner" :src="banner02_Src" @click="toPage('event4', lang)" /> -->
      <!-- <img class="banner" :src="couponBanner_Src" @click="toPage('coupons', lang)" />
      <img v-if="hiteachEventName != ''" class="banner" :src="hiteaach_Src" @click="toPage('event3', lang)" />  -->


      <div class="eventBox" @click="toPage('event5', lang)">
        <n-icon :component="Gift" size="50" color="#2196F3"/>
        <div class="eventBox-cont">
          <div class="eventBox-cont-title">{{ $t('discovery_15') }}</div>
          <span class="eventBox-cont-subTitle">{{ $t('discovery_16') }}</span>
        </div>
      </div>

      <div v-if="hiteachEventName != ''" class="eventBox" @click="toPage('event3', lang)">
        <n-icon :component="Gift" size="50" color="#2196F3"/>
        <div class="eventBox-cont">
          <div class="eventBox-cont-title">{{ hiteachEventName == 'hiteach333' ? 'HiTeach 333' : $t('hiteach50_text1')}}</div>
          <span class="eventBox-cont-subTitle">{{ hiteachEventName == 'hiteach333' ? $t('hiteach333_text15') : ''}}</span>
        </div>
      </div>
      
      <div class="eventBox" @click="toPage('coupons', lang)">
        <n-icon :component="Ticket" size="50" color="#ffc107"/>
        <div class="eventBox-cont">
          <div class="eventBox-cont-title">{{ $t('discovery_17') }}</div>
          <span class="eventBox-cont-subTitle">{{ $t('discovery_18') }}</span>
        </div>
      </div>

    </div>
    <h2 class="discovery-title" style="margin-top: 44px;">
      {{ $t('discovery_19') }}
    </h2>
    <div class="box" v-for="(item, key) in discoverys" :key="key" @click="toPage('article', lang, item.id, item.type)">
      <div class="box-img" v-bind:style="{ 'background-image': 'url(' + item.logo + ')' }"></div>
      <div class="box-cont">
        <div class="cont-title ellipsis">
          {{ item.title }}
        </div>
        <div class="cont-detail ellipsis">{{ item.subTitle }}</div>
        <div class="cont-time">
          {{ item.crtTime }} <span>{{ discoverysTypeStr(item.type) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import {reactive, ref, computed, watch, watchEffect} from 'vue'
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { computed, ref, defineComponent, onMounted} from "vue";
import { jsFn } from "@/utils/jsFn";
import { useI18n } from "vue-i18n";
import naiveFnc from "@/utils/naiveFnc";
import { Ticket, Gift} from '@vicons/ionicons5'

export default defineComponent({
  name: "discovery",
  setup() {
    //元件宣告
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const lang = route.params.lang;
    const i18n = useI18n();
    const { t } = i18n;
    const { crtDialog } = naiveFnc();

    // 變數宣告
    // var banner02_Src = "";
    // var couponBanner_Src = "";
    // var hiteaach333_Src = "";
    // var hiteaach50_Src = "";
    const tokens = computed(() => store.getters["coreApi/tokens"]);
    const events = computed(() => store.getters["coreApi/events"]);

    const hiteachEventName = ref('');
    // const hiteaach_Src = computed(()=>{
    //   let res = ''
    //   switch (hiteachEventName.value){
    //     case 'hiteach333':
    //       res = hiteaach333_Src;
    //     break;
    //     case 'hiteach50':
    //       res = hiteaach50_Src;
    //     break;
    //   }
    //   return res
    // })
       
    // 設定頁面的語系
    i18n.locale.value = lang;
    localStorage.setItem("lang", lang);

    // 圖檔設定
    // banner02_Src = require("@/assets/img/event2_banner_nofree_v2_" + lang + ".png");
    // couponBanner_Src = require("@/assets/img/coupon_banner_v2_" + lang + ".png");
    // hiteaach333_Src = require("@/assets/img/Hiteach333_" + lang + ".png");
    // hiteaach50_Src = require("@/assets/img/Hiteach50_" + lang + ".png");

    // 取得官網教育資訊
    store.dispatch("getOSNewsHTML", lang);

    // 取得學術發表資訊
    store.dispatch("getOSAcademicHTML", lang);

    // 取得活動專區資訊
    store.dispatch("getOSEventHTML", lang);

    // USER 快速登入
    onMounted(async() => {
      if (!jsFn.IsEmpty(route.query.code)) {
        // 先重置
        await store.dispatch("coreApi/resetState")

        var res = await store.dispatch("coreApi/codeLogin", route.query.code)
        if (res) {
          // 登入成功
          //取得個人額外活動資訊
          await store.dispatch("coreApi/getUsersetting", 'benefits')
          //取得個人在mynews的設定檔
          await store.dispatch("coreApi/getUsersetting", 'mynews')
          //取得個人在base-ex的設定檔
          await store.dispatch("coreApi/getUsersetting", 'base-ex')
          //取得個人的邀請碼
          await store.dispatch("coreApi/getReferralInfo")
          router.push({ path: "/" + lang })
        }
      }
      // 判斷顯示活動頁面
      if(events.value){
        events.value.forEach(x => {
          if(x.name == 'hiteach333' || x.name == 'hiteach50') {
            hiteachEventName.value = x.name
          }
        })
      }
    });

    // methods
    function toPage(path, lang, id, type) {
      switch (path) {
        case "article":
          router.push({ name: path, params: { lang: lang, type: type, id: id } });
          break;
        default:
          if (tokens.value.id_token !== "") {
            router.push({ name: path, params: { lang: lang } });
          } else {
            crtDialog(t("notice"), t("public_1"));
          }
      }
    }

    console.log(store.state.version, "version");

    

    return {
      discoverys: computed(() => {
        if(lang == 'jp' || lang == 'kr') {
          return store.getters["discoverysen"]
        } else {
          return store.getters["discoverys" + lang]
        }
      }),
      discoverysTypeStr: computed(()=>{
          return function(type){
              let str = ''
              switch(type) {
                case 'news':
                  str = t("EducationNews")
                break;
                case 'academic':
                  str = t("AcademicPapers")
                break;
                case 'event':
                  str = t("EventsSection")
                break;
              }
              
              return str
          }
      }),
      // hiteaach_Src,
      lang,
      toPage,
      // banner02_Src,
      // couponBanner_Src,
      hiteachEventName,
      Ticket,
      Gift
    };
  },
});
</script>
<style lang="less" scoped>
.ribbon-wrap{
  width: 67px;
  height: 66px;
  overflow: hidden;
  position: absolute;
  top: 19px;
  left: 25px;
}

.ribbon {
  position: relative;
  left: -23px;
  top: 5px;
  width: 94px;
  height: 14px;
  background-color: #d63411;
  color: transparent;
  // padding: 5px 0;
  text-align: center;
  transform: rotate(-45deg);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}


.discovery {
  &-title{
    text-align: center;
  }
  .icon {
    font-size: 100px;
  }
  .banner {
    max-width: 100%;
    height: auto;
  }
  .eventBox{
    display: flex;
    align-items: center;
    padding: 10px 17px;
    color: rgb(55, 71, 79);
    background-color: rgb(255, 255, 255);
    border-radius: 20px;
    margin: 5px;
    position: relative;
    border: 1px solid #737373;
    &-cont{
      margin-left: 10px;
      &-title{
        font-size: 23px;
        font-weight: bold;
      }
      &-subTitle{
        font-size: 13px;
        color: #757575;
      }
    }
  }
  .box {
    margin: 10px 12px;
    height: 320px;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    background-color: #ffffff;
    border-radius: 20px;
    border: 1px solid #737373;
    padding: 6px;
    position: relative;
    margin-bottom: 20px;
    &-img {
      background-repeat: no-repeat;
      background-size: cover;
      background-position: top;
      flex: 2;
      border-radius: 20px 20px 0px 0px;
    }
    &-cont {
      flex: 1;
      padding: 4px 12px;
      letter-spacing: 0.5px;
      .cont-title {
        font-weight: bolder;
        font-size: 16px;
        margin-bottom: 5px;
      }
      .cont-detail {
        color: #9e9e9e;
        font-size: 14px;
      }
      .cont-time {
        margin-top: 10px;
        font-size: 12px;
        letter-spacing: normal;
        span {
          color: #00bcd4;
          margin-left: 30px;
        }
      }
    }
  }
}
</style>
